export default {
  baseStyle: {
    fontFamily: 'Open Sans'
  },
  defaultProps: {
    variant: 'outline',
    focusBorderColor: 'yellow.400'
  }
}
